export default [
  {
    path: 'asked-questions',
    name: 'asked-questions',
    component: () => import('@/views/pages/front/AskedQuestions.vue'),
    meta: {
      pageTitle: 'Frequently asked questions',
      breadcrumb: [
        {
          text: 'Frequently asked questions',
          active: true,
        },
      ],
    },
  },
]
